import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const traySlice = createSlice({
  name: 'tray',
  initialState: {
    value: false, //is header tray open?
  },
  reducers: {
    setTray: (state, action: PayloadAction<boolean>) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setTray } = traySlice.actions;

export default traySlice.reducer;
